module.exports = __webpack_public_path__ + "b638228de1627bc3b52248cc41325759.png";